
import React from 'react';

import GmPerCm2 from './gPerCm2.svg';
import KgPerM2 from './kgPerM2.svg';

import * as styles from './styles.module.scss';

export const GramsDensityIcon = () => (
	<img className={styles.unit} src={GmPerCm2 as string} />
);

export const KiloDensityIcon = () => (
	<img className={styles.unit} src={KgPerM2 as string} />
);
